import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/password',
    name: 'Password',
    component: () => import(/* webpackChunkName: "about" */ '../views/Password.vue')
  },
  {
    path: '/list',
    name: 'List',
    component: () => import(/* webpackChunkName: "about" */ '../views/List.vue')
  },
  {
    path: '/table',
    name: 'Table',
    component: () => import(/* webpackChunkName: "about" */ '../views/Table.vue')
  },
    {
      path: '/analysis',
      name: 'Analysis',
      component: () => import(/* webpackChunkName: "about" */ '../views/Analysis.vue')
    },
    {
      path: '/static',
      name: 'Static',
      component: () => import(/* webpackChunkName: "about" */ '../views/Static.vue')
    },
    {
      path: '/test',
      name: 'Test',
      component: () => import(/* webpackChunkName: "about" */ '../components/score/CompCard.vue')
    },
    {
      path: '/update',
      name: 'Update',
      component: () => import(/* webpackChunkName: "about" */ '../views/UpdatePlayerMatchName.vue')
    },{
      path: '/downloadweekly',
      name: 'downloadweekly',
      component: () => import(/* webpackChunkName: "about" */ '../views/DownloadWeeklyReport.vue')
    },
    {
      path: '/map',
      name: 'Map',
      component: () => import(/* webpackChunkName: "about" */ '../views/Map.vue')
    },
    {
      path: '/rankings',
      name: 'Rankings',
      component: () => import(/* webpackChunkName: "about" */  '../views/Rankings.vue')
    },
    {
      path: '/svg',
      name: 'Svg',
      component: () => import(/* webpackChunkName: "about" */ '../views/TrySvg.vue')
    },
    {
      path: '/add_sub_event',
      name: 'AddSubEvent',
      component: () => import(/* webpackChunkName: "about" */  '../views/AddSubEvent.vue')
    },
    {
      path: '/training',
      name: 'TrainingAnalysis',
      component: () => import(/* webpackChunkName: "about" */  '../views/TrainingAnalysis.vue')
    },
  ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
